import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { RouterLink } from '@angular/router';
import { PartnersComponent } from '../../components/partners/partners.component';
import { LottieComponent } from '../../components/lottie/lottie.component';
import { CarouselComponent } from '../../components/carousel/carousel.component';
import { SharedModule } from '../../shared/shared.module';
import { MatDialog } from '@angular/material/dialog';
import { BroadfactorpayModalComponent } from '../../components/broadfactorpay-modal/broadfactorpay-modal.component';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  standalone: true,
  imports: [
    SharedModule,
    RouterLink,
    PartnersComponent,
    LottieComponent,
    CarouselComponent,
  ],
})
export class HomeComponent implements OnInit {
  constructor(private snackbar: MatSnackBar, private matDialog: MatDialog) {}

  ngOnInit() {
    // this.matDialog.open(BroadfactorpayModalComponent, {});
    // this.snackbar.openFromComponent(CareersSnackbarComponent, {
    //   data: {
    //     title: 'ESTAMOS CONTRATANDO!',
    //     subtitle: 'Temos vagas em aberto. Envie seu currículo.',
    //   },
    //   horizontalPosition: 'end',
    //   verticalPosition: 'bottom',
    //   panelClass: ['career-snackbar'],
    // });
  }

  openRegister() {
    let url = 'https://register.broadfactor.com/cedente';
    let origin_campaign = localStorage.getItem('origin_campaign');
    let origin_lead = localStorage.getItem('origin_lead');
    if (origin_campaign && origin_campaign !== 'undefined') {
      url = url + '?origin_campaign=' + origin_campaign;
    }
    if (origin_campaign && origin_campaign !== 'undefined') {
      url = url + '?origin_campaign=' + origin_campaign;
    }
    if (origin_lead && origin_lead !== 'undefined') {
      if (origin_campaign && origin_campaign !== 'undefined') {
        url = url + '&origin_lead=' + origin_lead;
      } else {
        url = url + '?origin_lead=' + origin_lead;
      }
    }
    window.open(url);
  }
}
